import { getTranslateDOMPositionXY } from 'dom-lib/lib/transition/translateDOMPositionXY';
const translateDOMPositionXY = getTranslateDOMPositionXY({ enable3DTransform: true });
export default translateDOMPositionXY;
